import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = 'https://ijvqkdbbweywhhasltor.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlqdnFrZGJid2V5d2hoYXNsdG9yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIyNzg0NjUsImV4cCI6MjA3Nzg1NDQ2NX0.90CKb_2nS5YPDPZ2PUiDpjbHcMmnSmXhmwSXa_2uFG4';

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Storage bucket name for events images
export const STORAGE_BUCKET = 'events-images';

// Database table name for events
export const EVENTS_TABLE = 'events';

